const jquery = require('jquery');
const googleMap = require('./gmap');

jquery(document).ready(function($) {

    window.commonMapFunction = function(mapInput, locationInput, location_id, location_lat, location_lng, location_address, location_address_detail, find_location_general, submit_button, role_user) {
        var $map = $('#' + mapInput);
        var $location = $map.closest('.location');
        if (document.getElementById(mapInput)){
            var map = new google.maps.Map(document.getElementById(mapInput), {
                center: {lat: 50.064192, lng: -130.605469},
                zoom: 3
            });
            var input = document.getElementById(locationInput);
            var autocomplete = new google.maps.places.Autocomplete(input);
            autocomplete.bindTo('bounds', map);
            autocomplete.setComponentRestrictions({'country': ['se']});

            var marker = new google.maps.Marker({
                map: map
            });

            window.searchCommonGoogleMap = function(){
                var k = $.Deferred();
                if (input.value.length > 0){
                    var sessionToken = new google.maps.places.AutocompleteSessionToken();
                    var displaySuggestions = function(predictions, status) {
                        if (status != google.maps.places.PlacesServiceStatus.OK) {
                            $location.find('input[name='+ location_id +']').val('');
                            $location.find('input[name='+ location_lat +']').val('');
                            $location.find('input[name='+ location_lng +']').val('');
                            $location.find('input[name='+ location_address +']').val('');
                            $location.find('input[name='+ location_address_detail +']').val('');
                            k.resolve();
                            return;
                        }
                        $location.find('input[name='+ location_id +']').val(predictions[0].place_id);
                        var service = new google.maps.places.PlacesService(map);
                        service.getDetails({
                            placeId: predictions[0].place_id,
                        }, function (result, status) {
                            if (!result.geometry) {
                                return;
                            }
                            if (result.geometry.viewport) {
                                map.fitBounds(result.geometry.viewport);
                                map.setZoom(11);
                            } else {
                                map.setCenter(result.geometry.location);
                                map.setZoom(17);
                            }
                            marker.setPlace({
                                placeId: result.place_id,
                                location: result.geometry.location
                            });
                            $location.find('input[name='+ location_address_detail +']').val(predictions[0].description);
                            $location.find('input[name='+ location_address +']').val(result.name);
                            $location.find('input[name='+ location_lat +']').val(result.geometry.location.lat());
                            $location.find('input[name='+ location_lng +']').val(result.geometry.location.lng());

                            marker.setVisible(true);
                            k.resolve();
                        });
                    };
                    var service = new google.maps.places.AutocompleteService();
                    service.getPlacePredictions({ input: input.value , sessionToken: sessionToken, componentRestrictions: {country: 'se'} }, displaySuggestions);
                } else {
                    k.resolve();
                }
                return k.promise();
            };

            $('#' + find_location_general).on('click',function (e){
                e.preventDefault();
                searchCommonGoogleMap();
            });
            $('#' + find_location_general).trigger('click');

            $('#' + submit_button).on('click',function (e){
                e.preventDefault();
                searchCommonGoogleMap().done(function () {
                    if (role_user == 'borrower'){
                        $('body').trigger('findLocationBorrower');
                    } else if (role_user =='owner'){
                        $('body').trigger('findLocationOwner');
                    }
                });
            });

            autocomplete.addListener('place_changed', function() {
                var place = autocomplete.getPlace();
                $location.find('input[name='+ location_id +']').val(place.place_id);
                if (!place.geometry) {
                    return;
                }

                if (place.geometry.viewport) {
                    map.fitBounds(place.geometry.viewport);
                } else {
                    map.setCenter(place.geometry.location);
                    map.setZoom(17);
                }

                marker.setPlace({
                    placeId: place.place_id,
                    location: place.geometry.location
                });

                // $location.find('input[name='+ location_address_detail +']').val(place.formatted_address);
                $location.find('input[name='+ location_address +']').val(place.name);
                $location.find('input[name='+ location_lat +']').val(place.geometry.location.lat());
                $location.find('input[name='+ location_lng +']').val(place.geometry.location.lng());

                marker.setVisible(true);
            });
        }
    };

    window.commonSearchMapFunction = function(mapInput, locationInput, location_lat, location_lng, find_location) {
        var $map = $('#' + mapInput);
        var $location = $map.closest('.location-search');
        if (document.getElementById(mapInput)){
            var map = new google.maps.Map(document.getElementById(mapInput), {
                center: {lat: 50.064192, lng: -130.605469},
                zoom: 3
            });
            var input = document.getElementById(locationInput);
            var autocomplete = new google.maps.places.Autocomplete(input);
            autocomplete.bindTo('bounds', map);
            autocomplete.setComponentRestrictions({'country': ['se']});

            var marker = new google.maps.Marker({
                map: map
            });

            window.searchCommonSearchGoogleMap = function(){
                var k = $.Deferred();
                if (input.value.length > 0){
                    var sessionToken = new google.maps.places.AutocompleteSessionToken();
                    var displaySuggestions = function(predictions, status) {
                        if (status != google.maps.places.PlacesServiceStatus.OK) {
                            $location.addClass('noPlace');
                            k.resolve();
                            return;
                        }
                        $location.removeClass('noPlace');
                        var service = new google.maps.places.PlacesService(map);
                        service.getDetails({
                            placeId: predictions[0].place_id,
                        }, function (result, status) {
                            if (!result.geometry) {
                                return;
                            }
                            if (result.geometry.viewport) {
                                map.fitBounds(result.geometry.viewport);
                                map.setZoom(15);
                            } else {
                                map.setCenter(result.geometry.location);
                                map.setZoom(17);
                            }
                            marker.setPlace({
                                placeId: result.place_id,
                                location: result.geometry.location
                            });
                            $location.find('.result-search').find('.address').text(result.name);
                            $location.find('input[name='+ location_lat +']').val(result.geometry.location.lat());
                            $location.find('input[name='+ location_lng +']').val(result.geometry.location.lng());
                            // marker.setVisible(true);
                            k.resolve();
                        });
                    };
                    var service = new google.maps.places.AutocompleteService();
                    service.getPlacePredictions({ input: input.value , sessionToken: sessionToken, componentRestrictions: {country: 'se'} }, displaySuggestions);
                } else {
                    k.resolve();
                }
                return k.promise();
            };

            $('#' + find_location).on('click',function (e){
                e.preventDefault();
                searchCommonSearchGoogleMap().done(function () {
                    var form = $location.closest('form');
                    var formClass = form.attr('class');
                    $('body').trigger('search', formClass);
                });
            });

            $('#' + find_location).trigger('click');
        }
    };

    googleMap.ready(function initSignUpLocationMap() {
            window.commonMapFunction('map-general-borrower','location-general-borrower', 'location_id_general_borrower', 'location_lat_general_borrower', 'location_lng_general_borrower', 'location_address_general_borrower', 'location_address_detail_general_borrower', 'find-location-general-borrower', 'submit-general-borrower', 'borrower');
            window.commonMapFunction('map-general-owner','location-general-owner', 'location_id_general_owner', 'location_lat_general_owner', 'location_lng_general_owner', 'location_address_general_owner', 'location_address_detail_general_owner', 'find-location-general-owner', 'submit-general-owner', 'owner');
            window.commonSearchMapFunction('mapSearch','locationSearch', 'lat-search', 'lng-search', 'find-more');
            var map = new google.maps.Map(document.getElementById('map'), {
                center: {lat: 50.064192, lng: -130.605469},
                zoom: 3
            });

            var input = document.getElementById('location');
            var autocomplete = new google.maps.places.Autocomplete(input);
            autocomplete.bindTo('bounds', map);
            autocomplete.setComponentRestrictions({'country': ['se']});

            var marker = new google.maps.Marker({
                map: map
            });

            window.searchGoogleMap = function(){
                var k = $.Deferred();
                if (input.value.length > 0){
                    var sessionToken = new google.maps.places.AutocompleteSessionToken();
                    var displaySuggestions = function(predictions, status) {
                        if (status != google.maps.places.PlacesServiceStatus.OK) {
                            $('#location-id').val('');
                            $('#location-lat').val('');
                            $('#location-lng').val('');
                            $('#location-address').val('');
                            $('#location-address-detail').val('');
                            k.resolve();
                            return;
                        }
                        $('#location-id').val(predictions[0].place_id);
                        var service = new google.maps.places.PlacesService(map);
                        service.getDetails({
                            placeId: predictions[0].place_id,
                        }, function (result, status) {
                            if (!result.geometry) {
                                return;
                            }
                            if (result.geometry.viewport) {
                                map.fitBounds(result.geometry.viewport);
                            } else {
                                map.setCenter(result.geometry.location);
                                map.setZoom(17);
                            }

                            marker.setPlace({
                                placeId: result.place_id,
                                location: result.geometry.location
                            });
                            $('#location-address-detail').val(predictions[0].description);
                            $('#location-address').val(result.name);
                            $('#location-lat').val(result.geometry.location.lat());
                            $('#location-lng').val(result.geometry.location.lng());

                            marker.setVisible(true);
                            k.resolve();
                        });
                    };
                    var service = new google.maps.places.AutocompleteService();
                    service.getPlacePredictions({ input: input.value , sessionToken: sessionToken, componentRestrictions: {country: 'se'} }, displaySuggestions);
                } else {
                    k.resolve();
                }
                return k.promise();
            };

            autocomplete.addListener('place_changed', function() {
                var place = autocomplete.getPlace();
                $('#location-id').val(place.place_id);
                if (!place.geometry) {
                    return;
                }

                if (place.geometry.viewport) {
                    map.fitBounds(place.geometry.viewport);
                } else {
                    map.setCenter(place.geometry.location);
                    map.setZoom(17);
                }

                marker.setPlace({
                    placeId: place.place_id,
                    location: place.geometry.location
                });

                // $('#location-address-detail').val(place.formatted_address);
                $('#location-address').val(place.name);
                $('#location-lat').val(place.geometry.location.lat());
                $('#location-lng').val(place.geometry.location.lng());

                marker.setVisible(true);
            });
        });
});





// WEBPACK FOOTER //
// ./resources/assets/js/google_map.js